import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  const footerLinks = [
    {
      title: "篇章导航",
      links: [
        { label: "忍者学校篇", href: "/category/ninja-academy" },
        { label: "波之国篇", href: "/category/land-of-waves" },
        { label: "中忍考试篇", href: "/category/chunin-exams" },
        { label: "疾风传篇", href: "/category/shippuden" },
        { label: "完结篇", href: "/category/final-arc" },
      ],
    },
    {
      title: "热门章节",
      links: [
        { label: "终结谷之战", href: "/article/chapter-014-valley-of-the-end" },
        { label: "自来也之死", href: "/article/chapter-016-jiraya-death" },
        { label: "佩恩入侵木叶", href: "/article/chapter-017-pain-invasion" },
        { label: "宇智波斑降临", href: "/article/chapter-019-madara-uchiha" },
        { label: "最终决战", href: "/article/chapter-020-final-battle" },
      ],
    },
    {
      title: "关于本站",
      links: [
        { label: "品牌故事", href: "/about" },
        { label: "用户口碑", href: "/about" },
        { label: "联系我们", href: "/about" },
      ],
    },
  ];

  return (
    <footer className="bg-secondary-50 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-fire-line text-background-50"></i>
                </div>
                <span className="text-lg font-bold text-foreground-950">
                  {t("site.name")}
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {t("site.subtitle")}。完整收录鸣人从忍者学校到火影之路的全部章节，是火影迷必收藏的漫画阅读平台。
              </p>
            </div>

            {footerLinks.map((section) => (
              <div key={section.title}>
                <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                  {section.title}
                </h4>
                <ul className="flex flex-col gap-2">
                  {section.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} {t("site.name")} — {t("footer.rights")}
            </p>
            <p className="text-xs text-foreground-400">
              {t("footer.disclaimer")}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}